import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import block from 'bem-cn';
import ProviderIcon from 'components/ProviderIcon';

import './GamesDetails.scss';

const b = block('games-details');

const GamesDetails = ({ games }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const GamesElements = useMemo(
    () =>
      games.map(({ game, changes }) => {
        return (
          <div key={game.id} className={b('game')}>
            <div className={b('header')}>
              <img src={game.imgUrl} className={b('game-icon')} alt="" />
              <div className={b('header-col')}>
                <div className={b('provider')}>
                  <div className={b('provider-icon')}>
                    <ProviderIcon name={game.provider.toLowerCase()} />
                  </div>
                  <span className={b('provider-name')}>{game.provider}</span>
                </div>
                <span className={b('game-name')}>{game.name}</span>
              </div>
              <span className={b('header-text')}>{locale.became}</span>
            </div>
            <div className={b('body')}>
              <div className={b('body-left')}>
                <span className={b('body-text')}>{locale.was}:</span>
              </div>
              <div className={b('body-right')}>
                {changes?.isActive !== undefined && (
                  <div className={b('changes-item')}>
                    <span className={b('changes-before')}>
                      {changes.isActive.before ? locale.itemActive : locale.itemDisabled}
                    </span>
                    <span
                      className={b('changes-after', {
                        variant: changes.isActive.after ? 'active' : 'disabled',
                      })}>
                      {changes.isActive.after ? locale.itemActive : locale.itemDisabled}
                    </span>
                  </div>
                )}
                {changes?.position !== undefined && (
                  <div className={b('changes-item')}>
                    <span className={b('changes-before')}>
                      {locale.valuePlace.replace('<value>', changes.position.before)}
                    </span>
                    <span className={b('changes-after')}>
                      {locale.valuePlace.replace('<value>', changes.position.after)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      }),
    [games, locale],
  );

  return (
    <div className={b()}>
      <div className={b('list')}>{GamesElements}</div>
    </div>
  );
};

export default GamesDetails;
